const GUARD_PREFIX = "itaas_sso_relay:";
const LOOP_WINDOW_MS = 8_000;

export function markSsoRelayAttempt(moduleId: string): void {
  sessionStorage.setItem(`${GUARD_PREFIX}${moduleId}`, String(Date.now()));
}

export function shouldBreakSsoRelayLoop(moduleId: string): boolean {
  const ts = Number(sessionStorage.getItem(`${GUARD_PREFIX}${moduleId}`) || 0);
  return ts > 0 && Date.now() - ts < LOOP_WINDOW_MS;
}

export function clearSsoRelayGuards(): void {
  for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
    const key = sessionStorage.key(i);
    if (key?.startsWith(GUARD_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  }
}
